import React, { useState, useEffect } from 'react';
import { MenuItem, FormControl, Select, Card, CardContent } from "@material-ui/core";
import InfoBox from "./Infobox";
import Map from "./Map";
import Table from "./Table";
import LineGraph from "./LineGraph";
import { sortData, prettyPrintStat } from "./util";
import "leaflet/dist/leaflet.css";
import numeral from "numeral";
import './App.css';


function App() {

  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState('worldwide')
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapZoom, setMapZoom] = useState(3);
  const [casesType, setCasesType] = useState("cases");
  const [mapCountries, setMapCountries] = useState([]);
  // state is how to write a varioable in react

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then(response => response.json())
      .then(data => {
        setCountryInfo(data);
      })
  }, [])

  //Disease.sh API call for countries GET
  // https://disease.sh/v3/covid-19/countries

  // Running a USEEFFECT --  a piece of code to run based on a given condition.
  // you can have several useEffects in a script. 

  useEffect(() => {
    // run an async code --> ASYNCHRONOUS = send a request, wait for it then do sth with the info

    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => (
            {
              name: country.country,  //United States, United Kingdom, France
              value: country.countryInfo.iso2 //UK, US, FR

            }
          ));

          const sortedData = sortData(data);
          // setTableData(data); == unsorted Data
          setTableData(sortedData);
          setCountries(countries);
          setMapCountries(data);
        });
    };

    getCountriesData();

  }, []);
  // when array left blank --> the code inside will run once when the component loads and not again after
  // let's say array is countries, it runs every time when country state changes

  // function to grab cahnge of dropdown click
  const onCountryChange = async (event) => {
    const countryCode = event.target.value;
    // console.log('Xlicked', countryCode); 
    // log the clicked country code
    setCountry(countryCode);

    // ternary operator
    // if world wide or selected country
    const url = countryCode === "worldwide" ? 'https://disease.sh/v3/covid-19/all'
      : `https://disease.sh/v3/covid-19/countries/${countryCode}`

    await fetch(url)
      .then(response => response.json())
      .then(data => {
        setCountry(countryCode);
        // all the data from a certain country response call  
        setCountryInfo(data);
        setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(4);

      });


  };
  console.log("Country Info", countryInfo);


  return (
    <div className="app">
      {/* Two Columns Left + Rigth */}

      <div className="app__left">

        {/* Header */}
        {/* Title + Select Input for nation */}
        <div className="app__header">

          <h1>COVID-19 Analytics by Arefat (Dev Build) </h1>

          <FormControl className="app__dropdown">

            <Select variant="outlined" onChange={onCountryChange} value={country}>

              <MenuItem value="worldwide">Worldwide</MenuItem>
              {/* Loop through all countries as dropdown option using state: short term memory */}

              {countries.map((country) => (
                <MenuItem value={country.value}>{country.name}</MenuItem>

              ))}

            </Select>
          </FormControl>

        </div>


        {/* InfoBoxes */}

        <div className="app__stats">

          {/* InfoBox Cases */}
          <InfoBox
            onClick={(e) => setCasesType("cases")}
            title="Coronavirus Cases"
            isRed
            active={casesType === "cases"}
            cases={prettyPrintStat(countryInfo.todayCases)}
            total={numeral(countryInfo.cases).format("0.0a")}
          />


          {/* total={numeral(countryInfo.cases).format("0.0a") */}

          {/* InfoBox Recovered */}
          <InfoBox
            onClick={(e) => setCasesType("recovered")}
            title="Recovered"
            active={casesType === "recovered"}
            cases={prettyPrintStat(countryInfo.todayRecovered)}
            total={numeral(countryInfo.recovered).format("0.0a")}
          />

          {/* InfoBox Death */}
          <InfoBox
            onClick={(e) => setCasesType("deaths")}
            title="Deaths"
            isRed
            active={casesType === "deaths"}
            cases={prettyPrintStat(countryInfo.todayDeaths)}
            total={numeral(countryInfo.deaths).format("0.0a")}
          />

        </div>

        {/* Map */}
        <Map casesType={casesType} countries={mapCountries} center={mapCenter} zoom={mapZoom} />

      </div>


      <Card className="app__right">

        <CardContent>
          <div className="app__information">

            <h3> Total Cases by Country</h3>
            {/* Tables */}

            <Table countries={tableData} />

            <div className="app__graph">
              <h3> Worldwide New {casesType}</h3>
              {/* Graph */}
              <LineGraph casesType={casesType} />
            </div>
          </div>
        </CardContent>

      </Card>

    </div>

  );
}

export default App;
